import React from "react";

export function WB_CustomEventsNextNEvents({}) {
    return <div>
        WB_CustomEventsNextNEvents
    </div>
}